import axios from "axios";
import { store } from "@/store.js";

// Ендпоінт-ЗАГЛУШКА для повернення Portmone (success_url).
// TODO: заміни на реальний, коли надішле бекенд.
const RETURN_ACTION = "paymentReturn";
const RETURN_SECTION = "tpay";

// Хост фронту tpay для локальної розробки (бо window.location = localhost).
// Заміни на потрібний сервер за потреби (staging / dev / прод-домен).
const DEV_TPAY_ORIGIN = "https://staging.tpay.skyservice.online";

// Формує адресу повернення після оплати — залежно від платіжки (store.activePaymentSystem
// з getStart, значення "Portmone" | "LiqPay" | null):
//  • Portmone повертається POST-ом → через бекенд-баунсер (приймає POST → 302 на відгуки);
//  • LiqPay (і будь-що крім Portmone) повертається GET-ом → ведемо прямо на відгуки
//    (статика віддає 200), баунсер не потрібен.
// null/інше → прямо (безпечний дефолт).
export const createUrlForReview = () => {
  // Кінцева ціль — сторінка відгуків SPA: у проді реальний хост сторінки,
  // локально (window.location = localhost) — DEV_TPAY_ORIGIN.
  const tpayOrigin =
    process.env.NODE_ENV === "production"
      ? window.location.origin
      : DEV_TPAY_ORIGIN;

  const reviewUrl = new URL(tpayOrigin);
  reviewUrl.search = window.location.search; // зберігаємо tpayid та інші параметри
  reviewUrl.searchParams.set("skyservice", "reviews");

  // LiqPay/інше — GET-ом прямо на відгуки, баунсер не потрібен.
  if (store.activePaymentSystem !== "Portmone") return reviewUrl.toString();

  // Portmone — POST-ом через бекенд-баунсер, який зробить 302 на reviewUrl.
  const successUrl = new URL(`https:${axios.defaults.baseURL}`);
  successUrl.searchParams.set("action", RETURN_ACTION);
  successUrl.searchParams.set("section", RETURN_SECTION);
  // .set() сам робить URL-encode вкладеного посилання.
  successUrl.searchParams.set("redirect", reviewUrl.toString());
  return successUrl.toString();
};
